function veda_fn_id_1728596905179_a1b2476eaf6d457aa56f17fa1f59a5ec() {
    
    try {
      const uniqueId = /* _____Start/Id_____ */"id_1728596905179_a1b2476e-af6d-457a-a56f-17fa1f59a5ec"/* _____End/Id_____ */;
      const containers = document.querySelectorAll(`[data-id="${uniqueId}"]:not(addons, megamenu)`);
      containers.forEach(container => {
        if (!container) {
          return;
        }
        veda.plugins.videoCover(container);
        /* _____Start/Content_____ */
        const type = container.getAttribute("data-review-type");
if (type != "star_rating") {
  const instance = veda.plugins.swiper(container);
  onCleanup(() => {
    instance.destroy();
  });
} else {
  const reviewSection = document.querySelector(
    "[data-scroll-id='veda-review']"
  );
  if (!reviewSection) {
    const starRatingEls = document.querySelectorAll(
      ".veda-review_rating[href='veda-review']"
    );
    starRatingEls.forEach((starRatingEl) => {
      starRatingEl.removeAttribute("href");
    });
  }
}

        /* _____End/Content_____ */
      });
    } catch (error) {
      console.log(error);
    }
  };
veda_fn_id_1728596905179_a1b2476eaf6d457aa56f17fa1f59a5ec();
